/* AFBDECOR behavior pass: menus, responsive search placement, desktop grid selector. */
(() => {
  const BREAKPOINT = 990;
  const GRID_KEY = 'afb_collection_grid_columns';
  const GRID_OPTIONS = [2, 3, 4, 6];

  function getHeader() {
    return document.querySelector('.afb-store-header');
  }

  function closeHeaderDetails(except) {
    const header = getHeader();
    if (!header) return;
    header.querySelectorAll('details[open]').forEach(detail => {
      if (detail !== except && !(except && detail.contains(except))) detail.removeAttribute('open');
    });
  }

  function initMenus() {
    const header = getHeader();
    if (!header || header.dataset.afbMenusReady === 'true') return;
    header.dataset.afbMenusReady = 'true';

    header.querySelectorAll('.afb-main-nav__dropdown, .afb-categories-menu').forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        header.querySelectorAll('.afb-main-nav__dropdown[open], .afb-categories-menu[open]').forEach(other => {
          if (other !== detail) other.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', event => {
      const currentHeader = getHeader();
      if (!currentHeader) return;
      currentHeader.querySelectorAll('details[open]').forEach(detail => {
        if (!detail.contains(event.target)) detail.removeAttribute('open');
      });
      const closeButton = event.target.closest('.afb-mobile-menu__head span');
      if (closeButton) closeButton.closest('.afb-mobile-menu')?.removeAttribute('open');
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeHeaderDetails();
    });
  }

  function moveSearch() {
    const header = getHeader();
    if (!header) return;
    const form = header.querySelector('.afb-header__search-form');
    const mainNav = header.querySelector('.afb-main-nav');
    const mobilePanel = header.querySelector('.afb-mobile-menu__panel');
    const mobileHead = header.querySelector('.afb-mobile-menu__head');
    if (!form) return;

    if (window.innerWidth >= BREAKPOINT && mainNav) {
      if (mainNav.nextElementSibling !== form) mainNav.insertAdjacentElement('afterend', form);
      header.classList.add('afb-search-merged--desktop');
      header.classList.remove('afb-search-merged--mobile');
    } else if (mobilePanel) {
      if (form.parentElement !== mobilePanel) {
        if (mobileHead) mobileHead.insertAdjacentElement('afterend', form);
        else mobilePanel.insertBefore(form, mobilePanel.firstChild);
      }
      header.classList.add('afb-search-merged--mobile');
      header.classList.remove('afb-search-merged--desktop');
    }
  }

  function getSavedColumns() {
    try {
      const saved = Number(localStorage.getItem(GRID_KEY));
      return GRID_OPTIONS.includes(saved) ? saved : 4;
    } catch (e) {
      return 4;
    }
  }

  function ensureGridButtons(control) {
    GRID_OPTIONS.forEach(columns => {
      let button = control.querySelector(`button[data-afb-columns="${columns}"]`);
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.dataset.afbColumns = String(columns);
        control.appendChild(button);
      }
      button.textContent = String(columns);
      button.setAttribute('aria-label', `${columns} columns`);
      button.setAttribute('title', `${columns} column view`);
    });
  }

  function clearGridClasses(grid) {
    if (!grid) return;
    GRID_OPTIONS.forEach(columns => grid.classList.remove(`afb-grid-cols-${columns}`));
  }

  function applyGridColumns(columns, persist = false) {
    const grid = document.querySelector('#ProductGridContainer #product-grid.grid.product-grid');
    const controls = document.querySelectorAll('.afb-grid-controls');
    if (!grid) return;

    if (window.innerWidth < BREAKPOINT || !controls.length) {
      clearGridClasses(grid);
      controls.forEach(control => control.querySelectorAll('[data-afb-columns]').forEach(button => button.setAttribute('aria-pressed', 'false')));
      return;
    }

    const value = GRID_OPTIONS.includes(Number(columns)) ? Number(columns) : 4;
    clearGridClasses(grid);
    grid.classList.add(`afb-grid-cols-${value}`);
    controls.forEach(control => {
      control.querySelectorAll('[data-afb-columns]').forEach(button => {
        button.setAttribute('aria-pressed', Number(button.dataset.afbColumns) === value ? 'true' : 'false');
      });
    });
    if (persist) {
      try { localStorage.setItem(GRID_KEY, String(value)); } catch (e) {}
    }
  }

  function initGridControls() {
    document.querySelectorAll('.afb-grid-controls').forEach(control => {
      ensureGridButtons(control);
      if (control.dataset.afbGridReady !== 'true') {
        control.dataset.afbGridReady = 'true';
        control.addEventListener('click', event => {
          const button = event.target.closest('button[data-afb-columns]');
          if (!button) return;
          event.preventDefault();
          applyGridColumns(Number(button.dataset.afbColumns), true);
        });
      }
    });
    applyGridColumns(getSavedColumns(), false);
  }

  function initObserver() {
    if (!document.body || document.body.dataset.afbPolishObserver === 'true') return;
    document.body.dataset.afbPolishObserver = 'true';
    let timer;
    new MutationObserver(mutations => {
      const relevant = mutations.some(mutation => Array.from(mutation.addedNodes).some(node => {
        if (!(node instanceof Element)) return false;
        return node.matches?.('.afb-grid-controls,#ProductGridContainer,#product-grid,.afb-store-header') || node.querySelector?.('.afb-grid-controls,#ProductGridContainer,#product-grid,.afb-store-header');
      }));
      if (!relevant) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        initMenus();
        moveSearch();
        initGridControls();
      }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initMenus();
    moveSearch();
    initGridControls();
    initObserver();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      moveSearch();
      initGridControls();
    }, 120);
  });

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
